import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.GetFirstName = {
  validator: '',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    if (Job.Data.backToSubmit === true) {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
    }
    else {
      onStepProgression()
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    $('#job-modal').data('bootstrapValidator').removeField('first_name')
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.EnterEmailAddress)
  },

  component: React.createClass({
    componentDidMount: function() {
      if (SS.currentUserId !== null && typeof SS.currentUserId !== "undefined") {
        if (SS.appFn.userHasPhoneForCurrentFlow()) {
          JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.VerifyNumber)
        }
        else {
          JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.CanCall)
        }
      }

      $('#job-modal').bootstrapValidator({ /* */ })
      JobWizardMobile.GetFirstName.validator = $('#job-modal').data('bootstrapValidator')
      this.setupValidation()
    },

    setupValidation: function () {
      JobWizardMobile.GetFirstName.validator.addField('first_name', {
        validators: {
          notEmpty: {
            message: 'Please enter your first name'
          },
          blank: {}
        }
      })
    },

    handleFirstNameChange: function(e) {
      Job.Actions.updateFirstName(e.target.value)
    },

    render() {
      return (
        <div>
          <h3 className="mb15 mt20">Can we get your first name?</h3>
          <div className="form-group">
            <div className="input-group p5 border radius-6 details-mobile">
              <input type="text" 
                     className="form-control" 
                     onChange={this.handleFirstNameChange} 
                     id="first_name"
                     name="first_name"
                     defaultValue={Job.Data.firstName}
              />
              <span className="input-group-btn">
                 <JobWizardMobile.NavigationButtons
                  navButtonLayout='okButton'
                  onStepProgression={this.props.onStepProgression}
                /> 
              </span>
            </div>
          </div>
        </div>
      )
    }
  })
}
